import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import loginService from "../../../services/login/loginService";
import HeaderAuth from "./HeaderAuth";
import HeaderUnauth from "./HeaderUnauth";
import HeaderUnTnc from "./HeaderUnTnc";
import "../../../assets/scss/components/header.scss";
import { MyAuthContext } from "../../../Context/AuthContext";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import { getTolocalStorage } from "../../Constants/commenFeatures";
import { accRedircet } from "../../../services/genralServise";
import { config } from "../../../config/domain";

const Header = (props) => {
  let myAuthContext = useContext(MyAuthContext);
  const [isNavbar, setIsNavbar] = useState(false);

  const showNavbar = async () => {
    await setIsNavbar(!isNavbar);
  };

  const logout = () => {
    let loginAs = getTolocalStorage("loginAs");
    if (loginAs === "vendor") {
      loginService.vendorLogout();
    } else {
      loginService.logout();
    }
    myAuthContext.isAuthFunction(false, false);
    accRedircet(config.root);
  };

  const gettingHeader = () => {
    if (myAuthContext && myAuthContext.isAuth && myAuthContext.tncAccepted) {
      return (
        <HeaderAuth
          logout={logout}
          isNavbar={isNavbar}
          showNavbar={showNavbar}
        />
      );
    } else if (
      myAuthContext &&
      myAuthContext.isAuth &&
      !myAuthContext.tncAccepted
    ) {
      return (
        <HeaderUnTnc
          isNavbar={isNavbar}
          showNavbar={showNavbar}
          logout={logout}
        />
      );
    } else {
      return <HeaderUnauth isNavbar={isNavbar} showNavbar={showNavbar} />;
    }
  };

  return (
    <div>
      <div className={isNavbar ? "header bg_black" : "header "}>
        <div className="container">
          <nav className="display-space-between mobileViewNav">
            <div className="head mobileViewHead">
              <Link to="/">
                <img src={NuvamaLogo} alt="nuvama-logo" />
              </Link>
              <a href="#main-content" className="skip-to-main"
                onClick={(e) => {
                  e.preventDefault();
                  const mainContent = document.getElementById("main-content");
                  if (mainContent) {
                    // ACCESSIBILITY: try to focus the first heading first —
                    // headings give the most useful context to screen reader users
                    // about what page they have landed on
                    const firstHeading = mainContent.querySelector("h1, h2");
                    if (firstHeading) {
                      // ACCESSIBILITY: tabIndex={-1} temporarily allows the heading
                      // to receive programmatic focus — removed after focus so it
                      // doesn't stay in the Tab order permanently
                      firstHeading.setAttribute("tabindex", "-1");
                      firstHeading.focus();
                      firstHeading.addEventListener(
                        "blur",
                        () => firstHeading.removeAttribute("tabindex"),
                        { once: true }
                      );
                    } else {
                      // ACCESSIBILITY: fallback — if no heading found focus the
                      // first focusable element inside main content
                      const firstFocusable = mainContent.querySelector(
                        "a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex='-1'])"
                      );
                      if (firstFocusable) firstFocusable.focus();
                    }
                  }
                }}>
                  Skip to main content
                </a>
              <button
                type="button"
                onClick={showNavbar}
                aria-expanded={isNavbar}
                aria-controls="main-navigation"
                aria-label={isNavbar ? "Close navigation menu" : "Open navigation menu"}
                className="nav-toggle-btn"
                onKeyDown={(e) => {
                  if (!isNavbar || e.key !== "Tab") return;
                  const menuElements = document.querySelectorAll(
                    ".mobileView a, .mobileView button, .mobileView [tabindex='0']"
                  );
                  if (!menuElements.length) return;
                  e.preventDefault();
                  if (e.shiftKey) {
                    menuElements[menuElements.length - 1].focus();
                  } else {
                    menuElements[0].focus();
                  }
                }}
              >
                {isNavbar ? (
                  <span>
                    <i className="edel-icon-close"></i>
                  </span>
                ) : (
                  <span className="">
                    <i className="edel-icon-bars"></i>
                  </span>
                )}
              </button>
            </div>
            <div className="mobileViewHide">{gettingHeader()}</div>
          </nav>
        </div>
      </div>
      {props.children}
    </div>
  );
};

export default Header;
